module.exports = __webpack_public_path__ + "img/sld_isolator_r1_l1_dark.3f6ddf05.svg";